var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddExpert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 138.61,
    width: 130.44,
    height: 6.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.8,
    y: 113.91,
    width: 5.75,
    height: 24.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.59,
    y: 113.91,
    width: 5.75,
    height: 24.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.28,
    y: 113.6,
    width: 5.75,
    height: 24.7,
    transform: "translate(-15.77 67.58) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.92,
    y: 117.17,
    width: 5.75,
    height: 21.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.13,
    y: 117.17,
    width: 5.75,
    height: 21.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.47,
    y: 117.17,
    width: 5.75,
    height: 21.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.53,
    y: 116.8,
    width: 5.75,
    height: 21.45,
    transform: "translate(-19.01 81.86) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.77,
    y: 112.68,
    width: 2.87,
    height: 25.93,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.95,
    y: 112.68,
    width: 2.87,
    height: 25.93,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.72,
    y: 119.06,
    width: 28,
    height: 19.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 188.65,
    width: 130.44,
    height: 6.7,
    transform: "translate(764.04 383.99) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.49,
    y: 163.94,
    width: 5.75,
    height: 24.7,
    transform: "translate(876.72 352.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.7,
    y: 163.94,
    width: 5.75,
    height: 24.7,
    transform: "translate(821.15 352.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.02,
    y: 163.63,
    width: 5.75,
    height: 24.7,
    transform: "translate(718.42 413.43) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.37,
    y: 167.2,
    width: 5.75,
    height: 21.45,
    transform: "translate(862.48 355.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.16,
    y: 167.2,
    width: 5.75,
    height: 21.45,
    transform: "translate(836.07 355.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.82,
    y: 167.2,
    width: 5.75,
    height: 21.45,
    transform: "translate(769.39 355.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.76,
    y: 166.83,
    width: 5.75,
    height: 21.45,
    transform: "translate(753.22 437.78) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.4,
    y: 162.72,
    width: 2.87,
    height: 25.93,
    transform: "translate(849.67 351.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.22,
    y: 162.72,
    width: 2.87,
    height: 25.93,
    transform: "translate(781.31 351.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.32,
    y: 169.09,
    width: 28,
    height: 19.33,
    transform: "translate(686.63 357.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53 266 53 383 59 383 59 278 165 278 165 383 172 383 172 266 53 266",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119 266 119 383 125 383 125 278 231 278 231 383 238 383 238 266 119 266",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,222.4c-1.34-2.2-3.54-.28-3.54-.28.31-4.23-3.57-7.11-3.57-7.11s4.51,0,5.14-4.31-1.57-2.3-3.64-2.33-4.23,6-1.5,9.4,2,9.2-4.3,14.77a12.36,12.36,0,0,0-3.29,5.13c.48-5.12.75-12.34-.76-17.15-2.56-8.19,2.32-10.39,3.73-14.48s-3.73-7.56-3.73-7.56,4.84-2.2,2.47-4.72-7.23-2.18-7.23,1.12,3.3,4.55,3.3,4.55,3.78,3.93,3.78,6-3.78,6.45-3.78,6.45,1.73-3.77-1.73-3.93-4.57,4.4-3.15,6.45,3.78.31,3.78.31a39.44,39.44,0,0,0,1.08,7.08c.35,1.18.19,5.8-.11,10.6a12,12,0,0,0-3.07-4.55c-6.29-5.57-7-11.37-4.3-14.77s.57-9.43-1.5-9.4-4.27-2-3.64,2.33,5.14,4.31,5.14,4.31-3.88,2.88-3.56,7.11c0,0-2.21-1.92-3.55.28-2.38,3.94,3.15,6.38,4.08,4.44,0,0,11.74,8.31,8.91,20.27l.66,1c-.09,1-.14,1.55-.14,1.55l.92-.39,1,1.54a36,36,0,0,0,.27,5.2l2.8-4.15c-2.83-12,8.91-20.27,8.91-20.27C153.73,228.78,159.27,226.34,156.88,222.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.77 266 145.98 244.31 147.05 238 135.12 238 136.19 244.31 132.41 266 149.77 266",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-6",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.95,
    y: 96.24,
    width: 35.01,
    height: 45.72,
    transform: "translate(89.57 -116.12) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.95,
    y: 96.24,
    width: 35.01,
    height: 45.72,
    transform: "translate(89.57 -116.12) rotate(28.37)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.37,
    y: 104.54,
    width: 24.56,
    height: 2.47,
    transform: "translate(84.11 -121.14) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.32,
    y: 108.35,
    width: 24.56,
    height: 2.47,
    transform: "translate(85.67 -119.71) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.26,
    y: 112.15,
    width: 24.56,
    height: 2.47,
    transform: "translate(87.23 -118.27) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.2,
    y: 115.96,
    width: 24.56,
    height: 2.47,
    transform: "translate(88.79 -116.84) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.15,
    y: 119.76,
    width: 24.56,
    height: 2.47,
    transform: "translate(90.35 -115.41) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.09,
    y: 123.57,
    width: 24.56,
    height: 2.47,
    transform: "translate(91.92 -113.97) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.04,
    y: 127.37,
    width: 24.56,
    height: 2.47,
    transform: "translate(93.48 -112.54) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.5,
    y: 129.12,
    width: 15.9,
    height: 2.47,
    transform: "translate(93.6 -109.54) rotate(28.37)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.89,107.59a22.15,22.15,0,1,1,24.29-19.78A22.18,22.18,0,0,1,218.89,107.59Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.15,
    cy: 85.55,
    r: 20.21,
    transform: "translate(-5.91 17.2) rotate(-4.4)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,79c-2.33-1.65-5.58-7.29-5.58-7.32l-2.1,20.44c.05-.46-1.77-.93-3-1-2.93-.31-5.4,1.07-5.6,3s2,3.85,5,4.15,5.37-1.08,5.58-3.06c0-.3-.21-.62-.18-.89l1.61-15.75a13.26,13.26,0,0,0,4.34,3.29c2.21,1,3,4.07,3,4.07A7.92,7.92,0,0,0,228,79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.82,
    cy: 80.9,
    rx: 15.94,
    ry: 13.21,
    transform: "translate(-12.68 109.82) rotate(-27.41)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.56,
    y: 58.69,
    width: 47.75,
    height: 35.75,
    transform: "translate(-5.69 12.84) rotate(-4.65)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.99,
    y: 61,
    width: 43,
    height: 31,
    transform: "translate(-5.68 12.85) rotate(-4.65)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.99,
    y: 61,
    width: 43,
    height: 31,
    transform: "translate(-5.68 12.85) rotate(-4.65)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.84 86 178.18 90.2 135.32 93.69 134.1 78.67 142.31 70.21 156.48 81.94 163.02 76.31 177.84 86",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.84 86 178.18 90.2 135.32 93.69 134.1 78.67 142.31 70.21 156.48 81.94 163.02 76.31 177.84 86",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.19,68a3.46,3.46,0,1,1-3.73-3.17A3.46,3.46,0,0,1,169.19,68Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.19,68a3.46,3.46,0,1,1-3.73-3.17A3.46,3.46,0,0,1,169.19,68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.39,98.87l-1.84-1.13a2.45,2.45,0,0,0-2.2-.19L74.18,101a2.14,2.14,0,0,0-1.31,1.66l-.3,2a2.08,2.08,0,0,1-1.3,1.65l-4.88,2a2.15,2.15,0,0,0-1.09,3l13,26.64a2.46,2.46,0,0,0,3.11,1.19L120.07,123a2.14,2.14,0,0,0,1.1-3l-13-26.63a2.46,2.46,0,0,0-3.11-1.2L88.59,99.06A2.45,2.45,0,0,1,86.39,98.87Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,93.16,74.59,108a3.21,3.21,0,0,0-1.8,3.87l7.75,24.53A2.6,2.6,0,0,0,84.09,138l35.42-14.82a3.23,3.23,0,0,0,1.8-3.87l-7.76-24.53A2.59,2.59,0,0,0,110,93.16Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,93.16,74.59,108a3.21,3.21,0,0,0-1.8,3.87l7.75,24.53A2.6,2.6,0,0,0,84.09,138l35.42-14.82a3.23,3.23,0,0,0,1.8-3.87l-7.76-24.53A2.59,2.59,0,0,0,110,93.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.48,152a30.13,30.13,0,0,0,.66-6.28,29.82,29.82,0,0,0-29.82-29.82,30.36,30.36,0,0,0-5.51.51c-.76-.14-1.53,0-2.32-.09A34.92,34.92,0,0,0,169.5,96h-11a35,35,0,0,0-35.17,34.92c0,.26,0,.39,0,.65a29.44,29.44,0,0,0,5.4,58.43h108a19,19,0,0,0,1.73-38Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,152a30.13,30.13,0,0,0,.66-6.28,29.82,29.82,0,0,0-29.82-29.82,30.36,30.36,0,0,0-5.51.51c-.76-.14-1.53,0-2.32-.09A34.92,34.92,0,0,0,169.5,96h-11a35,35,0,0,0-35.17,34.92c0,.26,0,.39,0,.65a29.44,29.44,0,0,0,5.4,58.43h108a19,19,0,0,0,1.73-38Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,152a30.13,30.13,0,0,0,.66-6.28,29.82,29.82,0,0,0-29.82-29.82,30.36,30.36,0,0,0-5.51.51c-.76-.14-1.53,0-2.32-.09A34.92,34.92,0,0,0,169.5,96h0a35,35,0,0,0-35.17,34.92c0,.26,0,.39,0,.65a29.44,29.44,0,0,0,5.4,58.43h97a19,19,0,0,0,1.73-38Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.67,239H234a50.06,50.06,0,0,1-50-50V179H174v10a60.07,60.07,0,0,0,60,60h33.67Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.88 172.34 170.21 181 187.54 181 178.88 172.34",
    style: {
      fill: "#C40A36"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stuff--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.28,367.33l-6-18.33A26.16,26.16,0,0,1,120,343.17l5,17.16Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.28,367.33l-6-18.33A26.16,26.16,0,0,1,120,343.17l5,17.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.14,353.33a16.21,16.21,0,0,1,2.37-2.17,21.28,21.28,0,0,1,2.78-1.82c.53-.28,1.09-.58,1.68-.84s1.18-.51,1.81-.7a17.92,17.92,0,0,1,1.87-.52l.93-.21.93-.11c.3,0,.6-.09.89-.11h.86a9,9,0,0,1,1.58.05c.48.05.92.09,1.31.16l1,.23.85.22s-.33,0-.88,0l-1-.05-1.3,0a13.89,13.89,0,0,0-1.51.12,14.68,14.68,0,0,0-1.67.25l-.88.16-.88.23a16.45,16.45,0,0,0-1.78.53c-.61.16-1.18.43-1.76.64s-1.12.48-1.65.73-1,.5-1.52.77-.93.5-1.34.74c-.82.48-1.5.89-2,1.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.67,355s.23-.2.67-.51,1.06-.76,1.85-1.22a30.1,30.1,0,0,1,2.77-1.48c1-.5,2.19-.94,3.34-1.36.59-.17,1.18-.37,1.76-.53s1.17-.3,1.74-.39,1.12-.22,1.65-.26,1-.11,1.49-.12a17.22,17.22,0,0,1,2.22.08l.84.1s-.31.05-.84.1c-.26,0-.58,0-.94.1l-1.22.19c-.45.07-.92.2-1.43.29s-1,.26-1.57.38-1.1.32-1.67.46-1.13.37-1.7.55c-2.28.76-4.51,1.68-6.18,2.39-.83.37-1.54.65-2,.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.08,358.42a7,7,0,0,1,.62-.55c.4-.33,1-.8,1.72-1.31a26,26,0,0,1,2.63-1.59,27.87,27.87,0,0,1,3.21-1.47,23.91,23.91,0,0,1,3.4-1,14.11,14.11,0,0,1,1.62-.24c.52,0,1-.11,1.46-.1l1.23.05c.37,0,.68.09.94.12l.81.14s-.3,0-.82.05c-.26,0-.57,0-.92.06l-1.2.16c-.43.05-.89.17-1.39.25s-1,.26-1.53.37-1.06.33-1.61.48-1.09.38-1.64.57-1.09.41-1.62.64-1.06.43-1.55.67c-1,.45-1.93.91-2.72,1.3s-1.46.73-1.91,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.92,360.75a16.32,16.32,0,0,1,2.25-1.86,22.54,22.54,0,0,1,2.58-1.54c.5-.24,1-.48,1.55-.7s1.09-.43,1.66-.59a17.16,17.16,0,0,1,1.71-.44,12.88,12.88,0,0,1,1.69-.27,11,11,0,0,1,1.6-.09,9.3,9.3,0,0,1,1.42.06l1.2.16.9.22c.49.13.77.22.77.22s-.3,0-.8,0l-.91,0-1.17,0A11.28,11.28,0,0,0,117,356a14.55,14.55,0,0,0-1.52.21c-.52.07-1,.22-1.6.34s-1.08.29-1.62.45a31.35,31.35,0,0,0-3.14,1.14c-1,.42-1.89.85-2.66,1.23s-1.41.72-1.85,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.08,363.87a6.85,6.85,0,0,1,.59-.55c.39-.33.94-.8,1.65-1.31a24.45,24.45,0,0,1,2.53-1.59c.47-.27,1-.53,1.5-.77s1.07-.45,1.61-.69,1.11-.38,1.66-.55,1.11-.29,1.66-.39a15.44,15.44,0,0,1,1.57-.21c.51,0,1-.08,1.43-.06l1.2.08c.35,0,.66.12.91.16l.78.18-.8,0c-.25,0-.56,0-.9,0l-1.16.11c-.42.05-.88.16-1.35.22s-1,.24-1.49.34-1,.32-1.57.46-1.06.36-1.59.56-1.06.4-1.57.63-1,.43-1.5.67c-1,.45-1.85.91-2.62,1.3s-1.41.72-1.84,1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M101.68,367.46,114,358.12a1.33,1.33,0,0,1,1.07-.25l14.07,2.67a1.35,1.35,0,0,1,.39,2.52l-11.61,6.29a1.46,1.46,0,0,1-.61.16l-14.8.38A1.35,1.35,0,0,1,101.68,367.46Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.89,373s18.94-45.83,22.28-48.67,24.5,9.47,24.5,9.47l-18.84,48.37Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,372.67s18.14-43.78,20.84-45.67,18.16,6.17,18.16,6.17-16.11-9.84-21.05-8.17-21.78,46.67-21.78,46.67Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.06,
    y: 368.5,
    width: 80.44,
    height: 47.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.06,
    y: 368.5,
    width: 80.44,
    height: 47.5,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.56,
    y: 368.5,
    width: 49.94,
    height: 47.5,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.56 369 136.5 353.75 178.75 356.63 167.5 369 117.56 369",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.56 369 103.25 352.5 73 355.75 87.06 368.5 117.56 369",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.56 369 103.25 352.5 73 355.75 87.06 368.5 117.56 369",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.56 369 136.5 353.75 178.75 356.63 167.5 369 117.56 369",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.27,390.36a12.78,12.78,0,1,0,12.78,12.78A12.78,12.78,0,0,0,152.27,390.36Zm0,17.87a5.1,5.1,0,1,1,5.1-5.09A5.09,5.09,0,0,1,152.27,408.23Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,397.59a12.38,12.38,0,0,0-.78-1.37,11.39,11.39,0,0,0-1.28-1.67,12.64,12.64,0,0,0-8.47-4.14,8.21,8.21,0,0,0-1-.05,12.79,12.79,0,0,0-12.39,15.88,10.48,10.48,0,0,0,.46,1.44,11.51,11.51,0,0,0,1,2,12.75,12.75,0,0,0,9.84,6.15c.37,0,.74.05,1.11.05a12.79,12.79,0,0,0,11.52-18.32Zm-11.52,10.64a3.87,3.87,0,0,1-.48,0,5.07,5.07,0,0,1-4.23-3.13,5.53,5.53,0,0,1-.28-.9,5.41,5.41,0,0,1-.07-.58,3.4,3.4,0,0,1,0-.45,5.09,5.09,0,0,1,5.09-5.1,2.17,2.17,0,0,1,.36,0,5.06,5.06,0,0,1,2.87,1.12,4.85,4.85,0,0,1,.56.55,3.9,3.9,0,0,1,.4.51,5,5,0,0,1,.91,2.9A5.09,5.09,0,0,1,152.27,408.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,408.2l-.63,7.66a12.75,12.75,0,0,1-9.84-6.15l6.24-4.64A5.07,5.07,0,0,0,151.79,408.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.73,394.55l-6.23,4.63a5.06,5.06,0,0,0-2.87-1.12l.63-7.65A12.64,12.64,0,0,1,161.73,394.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.28,404.17l-6.94,3.51a10.48,10.48,0,0,1-.46-1.44l7.33-2.65A5.41,5.41,0,0,0,147.28,404.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,397.59l-7.33,2.65a3.9,3.9,0,0,0-.4-.51l6.95-3.51A12.38,12.38,0,0,1,163.79,397.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.6,393.91c-7,0-10.83,4.93-8.43,11s10.05,11,17.1,11,10.84-4.92,8.44-11S168.66,393.91,161.6,393.91Zm6.07,15.39a7.76,7.76,0,0,1-6.82-4.39c-1-2.42.55-4.39,3.36-4.39a7.78,7.78,0,0,1,6.82,4.39C172,407.33,170.48,409.3,167.67,409.3Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,400.13c-.39-.4-.8-.8-1.24-1.18a17.8,17.8,0,0,0-1.85-1.43,19.87,19.87,0,0,0-9.87-3.57c-.35,0-.68,0-1,0-7,0-10.83,4.92-8.43,11a13,13,0,0,0,1.43,2.67,12,12,0,0,0,1,1.24,16.14,16.14,0,0,0,1.67,1.75,20.4,20.4,0,0,0,11.92,5.3c.38,0,.76,0,1.13,0,7.06,0,10.84-4.93,8.45-11A15.14,15.14,0,0,0,175.57,400.13Zm-7.91,9.17-.49,0a8.16,8.16,0,0,1-5.29-2.69,6.06,6.06,0,0,1-.58-.78,4.82,4.82,0,0,1-.27-.5,3.39,3.39,0,0,1-.18-.39c-1-2.43.55-4.39,3.36-4.39a2.17,2.17,0,0,1,.36,0,7.69,7.69,0,0,1,3.25,1,7.34,7.34,0,0,1,.75.48,4.81,4.81,0,0,1,.57.44,6.28,6.28,0,0,1,1.9,2.49C172,407.33,170.48,409.3,167.66,409.3Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,409.27l2,6.6a20.4,20.4,0,0,1-11.92-5.3l4.66-4A8.16,8.16,0,0,0,167.17,409.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48,397.52l-4.66,4a7.69,7.69,0,0,0-3.25-1l-2-6.59A19.87,19.87,0,0,1,172.48,397.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3,405.8l-5.75,3a12,12,0,0,1-1-1.24L161,405.3A4.82,4.82,0,0,0,161.3,405.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,400.13l-6.43,2.29a4.81,4.81,0,0,0-.57-.44l5.76-3C174.77,399.33,175.18,399.73,175.57,400.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 330 372.76 345.57 374.4 416 379.81 416 381.44 345.57 381.8 330 372.4 330",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 330 372.76 345.57 374.4 416 379.81 416 381.44 345.57 381.8 330 372.4 330",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 330 372.76 346 381.44 346 381.8 330 372.4 330",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.02 415.75 348.02 331.1 356.19 331.1 349.19 415.75 343.02 415.75",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.21 415.75 343.03 415.75 347.57 338.7 348.02 331 356.19 331 355.56 338.7 349.21 415.75",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.19 331 355.56 339 347.57 339 348.02 331 356.19 331",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.02 415.75 398.02 331.1 406.19 331.1 411.19 415.75 405.02 415.75",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405 415.75 398.65 338.7 398.02 331 406.19 331 406.64 338.7 411.18 415.75 405 415.75",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.02 331 398.65 339 406.64 339 406.19 331 398.02 331",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.65,322.33h66.92a0,0,0,0,1,0,0V329a5,5,0,0,1-5,5H348.65a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,343.65,322.33Z",
    transform: "translate(754.21 656.36) rotate(180)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 328.18,
    width: 73.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(754.21 662.2) rotate(180)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 328.18,
    width: 73.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(754.21 662.2) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.09,227.5s-.28.76-.79,2-1.29,3.13-2.24,5.19c-2.3,5-5.64,11.36-9.13,14.79a9.4,9.4,0,0,1-3.1,2.16c-3.72,1.43-13.05,1.69-21.38,1.61s-15.45-.5-15.45-.5v-6.31l27.39-7.3s14.44-26.06,23-29.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,229.51c-.52,1.3-1.29,3.13-2.24,5.19-2.3,5-5.64,11.36-9.13,14.79-3.55-13.08,9.58-25.53,9.58-25.53Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.76 408.78 340.79 407.69 339.69 388.75 347.64 389.85 348.76 408.78",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.64 389.85 339.69 388.76 340.32 399.58 348.27 400.28 347.64 389.85",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.44,297.46l1.94-12.18L395,282.61s4.75,25.34,1.1,32.09c-6.51,12.05-41.61,6-51.89,7.15C350.39,347,349.79,396,349.79,396l-14.67,1.12s-11.28-52.87-13.57-78C320,302.2,334.06,302.62,348.44,297.46Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.51 396.73 333.88 397.88 332.37 390.33 351.74 389.44 351.51 396.73",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.38 401.71 322.36 402.3 317.34 384.01 325.35 383.43 330.38 401.71",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.28,402.57l-.14,0h0c0-.12-.41-2.37-1.38-2.9a.9.9,0,0,0-.8,0,.7.7,0,0,0-.49.73,3,3,0,0,0,1.18,1.63,3.21,3.21,0,0,0-2.24.06.71.71,0,0,0-.28.63,1,1,0,0,0,.51.94,2.15,2.15,0,0,0,1.56,0,10,10,0,0,0,2-.84h.07s0,0,0-.06A.16.16,0,0,0,321.28,402.57Zm-2.41-2.24c0-.11,0-.25.27-.35l.09,0a.5.5,0,0,1,.43.05c.58.31,1,1.53,1.17,2.26l-.18-.05C319.86,401.77,318.94,400.87,318.87,400.33Zm-1.05,2.94a.71.71,0,0,1-.31-.61.36.36,0,0,1,.13-.31c.46-.34,1.92-.05,3,.27C319.31,403.28,318.29,403.52,317.82,403.27Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.35 383.43 317.34 384.02 320.21 394.47 328.13 393.5 325.35 383.43",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.62,393.18,328.74,389s-8.43-47.58-17-64.08c.64-.21,1.49-.48,2.54-.79,1.89-.57,4.4-1.28,7.35-2.1,20.52-5.69,62.11-16.36,62.11-16.36l-19-17.73s-75.68,11.54-77.25,31.48C286.76,329,314.62,393.18,314.62,393.18Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.56 389.34 313.56 394.15 310.51 387.08 329.27 382.17 330.56 389.34",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3,324.16c1.89-.57,4.4-1.28,7.35-2.1-.59-4.84-.6-10.39,1.73-13.22,4.63-5.64,16.54-8.95,23.32-10.15,5.67-1,24.72-3,24.72-3s-24.72-2.37-50,5C308.94,304.35,311.37,316.56,314.3,324.16Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.52,295.34c3-2.29.12-23.59,1.65-44.54,2.33-31.9,0-42.15-2.35-43.14a90.4,90.4,0,0,0-13.13-1.3,168.12,168.12,0,0,0-19.31.42,84.74,84.74,0,0,0-13,2.64s-10.52,33.5-3.8,81.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,234.38s0,0,0,0c-.13,4.69-.41,10.13-.87,16.41-1.53,20.95,1.33,42.25-1.65,44.54l-49.95-4.17a225.22,225.22,0,0,1-.05-63.15c4.06-6.34,11.94-13.57,15.56-16.74a7.52,7.52,0,0,0,4.6,2.39c3.89.76,8.33-1,12-3.24,2.9,2.89,8.4,8.74,10.81,13.67a15.72,15.72,0,0,1,.67,1.57c1.53,4.28,6.2-1,8.58-7.88A149,149,0,0,1,400,234.38Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,184.71c-1.09,6.24-2.06,17.64,2.37,21.7a20,20,0,0,1-14,6.36c-8,.35-5.3-6-5.3-6,6.9-1.8,6.6-6.94,5.29-11.74Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.57,188.94l-6.89,6.14a19.78,19.78,0,0,1,.67,3.41c2.64-.43,6.21-3.42,6.44-6.2A9.22,9.22,0,0,0,376.57,188.94Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.19,168.56c3.45,2.34,1.88,6.3-5.92,12.51C357.11,177,356.58,169,359.1,167S363.19,166.53,366.19,168.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,175c-.37,8.43-.17,13.37-4.34,17.77-6.28,6.61-16.74,2.93-18.89-5.44-1.92-7.52-1-20,7.19-23.53A11.49,11.49,0,0,1,381,175Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.49,177.5c0,.69-.34,1.25-.79,1.26s-.81-.54-.82-1.23.33-1.24.78-1.25S368.43,176.83,368.49,177.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7,177.65c0,.68-.34,1.24-.79,1.25s-.82-.53-.83-1.23.34-1.25.79-1.25S360.69,177,360.7,177.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.25,177.93a24.39,24.39,0,0,1-3.17,5.91,4,4,0,0,0,3.28.56Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,175a.36.36,0,0,0,.25-.06.4.4,0,0,0,.08-.56,4,4,0,0,0-3.31-1.61.38.38,0,0,0-.36.41v0a.41.41,0,0,0,.43.36h0a3.18,3.18,0,0,1,2.6,1.3A.44.44,0,0,0,370.58,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.11,175.08a.41.41,0,0,0,.37-.23,3.17,3.17,0,0,1,2.23-1.86.41.41,0,0,0,.34-.46.4.4,0,0,0-.45-.34,4,4,0,0,0-2.85,2.32.4.4,0,0,0,.19.53h0A.32.32,0,0,0,357.11,175.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.54,167.58c-3.91,1.42-3.35,5.65,2.69,13.57,4.08-3.21,6.55-10.82,4.58-13.37S381,166.35,377.54,167.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.15,181.65a8,8,0,0,1-3.73,4.86c-2.45,1.38-4.34-.65-4.23-3.3.11-2.4,1.51-6,4.24-6.3S385.81,179.13,385.15,181.65Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.68,185.79a5.88,5.88,0,0,1-5.54,2.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.526291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,166.24s1.26,8.44,9.39,9,9.87-4.49,9.87-4.49a15.54,15.54,0,0,1-2,.16s2.38-4.09,0-8-10.48-8.09-16.49-6a14.27,14.27,0,0,0-11.38,1.1c-5.63,3.27-4.63,10.4-4.63,10.4s-.25-4.33,2.38-5.54c0,0-3.25,8.91,1.62,11.29C357.75,174.13,358.23,165.36,369,166.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.17,246s-29-.66-30.64-.82-8.51-4-10-4.21-5.38,6-5.87,7.44,11,5.34,12.11,5.17a20.69,20.69,0,0,0,3.73-1.39l29.6,3.81Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,252v2.65c0,.79,1.36,1.35,2.15,1.35h61.79c.8,0,2.06-.56,2.06-1.35V252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,252v2.65c0,.79,1.36,1.35,2.15,1.35h61.79c.8,0,2.06-.56,2.06-1.35V252Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,252v2.65c0,.79,1.36,1.35,2.15,1.35H313.9c.8,0,2.1-.56,2.1-1.35V252Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,219.51,268.45,253a2.61,2.61,0,0,0,2.39,2H311a1.74,1.74,0,0,0,1.51-2.24l-7.35-33.12a2.3,2.3,0,0,0-2.39-1.64H262.61C261.53,218,260.85,218.42,261.09,219.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,219.51,268.45,253a2.61,2.61,0,0,0,2.39,2H311a1.74,1.74,0,0,0,1.51-2.24l-7.35-33.12a2.3,2.3,0,0,0-2.39-1.64H262.61C261.53,218,260.85,218.42,261.09,219.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,219.51,268.45,253a2.61,2.61,0,0,0,2.39,2h38.81a1.75,1.75,0,0,0,1.52-2.24l-7.35-33.12a2.3,2.3,0,0,0-2.39-1.64H262.61C261.53,218,260.85,218.42,261.09,219.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,241c-1.87,0-3.79-2-4.28-4.48S281.09,232,283,232a2.91,2.91,0,0,1,1,.2,5.74,5.74,0,0,0,3.19,4.09,1.46,1.46,0,0,1,.05.2C287.74,239,286.61,241,284.73,241Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,234.38s0,0,0,0c-4.31,7-10.34,14.45-16.35,14.1-6.29-.37.05-13.21,6.81-24.39a15.72,15.72,0,0,1,.67,1.57c1.53,4.28,6.2-1,8.58-7.88A149,149,0,0,1,400,234.38Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.82,207.66c14.83,5.34-11.2,45.5-19.29,49.64s-29.35-.63-29.35-.63l1.32-12.41s16.83,1.14,20.18.29,11.31-18,15.89-26.05A25.84,25.84,0,0,1,396.82,207.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.51 396.73 333.88 397.88 332.37 390.33 351.74 389.44 351.51 396.73",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.56 389.34 313.56 394.15 310.51 387.08 329.27 382.17 330.56 389.34",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.58,401.48l8.68-2.42a.58.58,0,0,1,.72.36h0l2.35,6.76a1.43,1.43,0,0,1-1,1.75c-3.05.79-4.54,1-8.37,2.06-2.35.65-6.93,2.15-10.28,2.53s-3.63-2.94-2.25-3.39c3.28-1.1,7.21-4.52,8.91-6.84A2.27,2.27,0,0,1,321.58,401.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,407.7h0c0-.14-.14-2.41-1-3.13a1.16,1.16,0,0,0-.9-.21.77.77,0,0,0-.68.6,2.89,2.89,0,0,0,.79,1.84,3.31,3.31,0,0,0-2.22-.41.74.74,0,0,0-.41.56,1,1,0,0,0,.3,1,2.13,2.13,0,0,0,1.52.3,9.31,9.31,0,0,0,2.1-.42.08.08,0,0,0,.07,0l0-.06s.19,0,.2-.07.17,0,.17,0ZM337.79,405c0-.11.07-.25.33-.3h.09a.51.51,0,0,1,.41.15c.51.42.65,1.69.68,2.45l-.16-.09A3.78,3.78,0,0,1,337.79,405Zm-1.64,2.65A.7.7,0,0,1,336,407a.33.33,0,0,1,.2-.27c.51-.24,1.88.35,2.85.88C337.61,408,336.55,408,336.15,407.69Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,406.73l9-.56a.56.56,0,0,1,.63.5h0l.88,7.1a1.4,1.4,0,0,1-1.31,1.5c-3.14.15-4.65.06-8.61.28-2.43.14-7.22.66-10.58.33s-2.94-3.63-1.49-3.79c3.43-.39,8-2.91,10.13-4.83A2.24,2.24,0,0,1,340.19,406.73Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "300.11 416 306.23 416 307.24 262.75 299.11 262.75 300.11 416",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.1 263 299.26 287.73 300.1 416 306.23 416 307.07 287.73 307.23 263 299.1 263",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.1 263 299.26 288 307.07 288 307.23 263 299.1 263",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.07 416 241.19 416 252.2 262.75 244.07 262.75 235.07 416",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.06 416 241.19 416 251.66 270.37 252.2 263 244.07 263 243.63 270.37 235.06 416",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.63 270 251.66 270 252.2 263 244.07 263 243.63 270",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.15 416 371.27 416 362.27 262.75 354.14 262.75 365.15 416",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.14 263 354.68 270.37 365.15 416 371.27 416 362.71 270.37 362.27 263 354.14 263",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.27 263 354.14 263 354.68 270 362.71 270 362.27 263",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,258.92H366.55a2.16,2.16,0,0,1,2.16,2.16v5.51a0,0,0,0,1,0,0H237.63a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,239.79,258.92Z",
    transform: "translate(606.34 525.51) rotate(180)",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,258.92H366.55a2.16,2.16,0,0,1,2.16,2.16v5.51a0,0,0,0,1,0,0H237.63a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,239.79,258.92Z",
    transform: "translate(606.34 525.51) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 258.92,
    width: 131.08,
    height: 3.84,
    transform: "translate(606.34 521.67) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.83,259.92H372.51a2.17,2.17,0,0,0,2.16-2.17h0a2.16,2.16,0,0,0-2.16-2.16H233.83a2.16,2.16,0,0,0-2.16,2.16h0A2.17,2.17,0,0,0,233.83,259.92Z",
    style: {
      fill: "#C40A36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.83,259.92H372.51a2.17,2.17,0,0,0,2.16-2.17h0a2.16,2.16,0,0,0-2.16-2.16H233.83a2.16,2.16,0,0,0-2.16,2.16h0A2.17,2.17,0,0,0,233.83,259.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddExpert);
export default __webpack_public_path__ + "static/media/addExpert.824ac4ab6a99f2191d6d1d62a0bb30e4.svg";
export { ForwardRef as ReactComponent };